import { useQuery } from 'react-query'

import axios from 'axios'


const getExportToCsv = async ({csvExportApi}) => {
	let response = await axios.get(`${csvExportApi}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
	return response.data
}

export const useGetExportToCsv = (
	{csvExportApi}
) => {
	return useQuery(
		['exportCsvData',csvExportApi],
		() => getExportToCsv({csvExportApi}),
		{
			enabled: false,
		},
	)
}

const getExportToCsvContent = async ({csvExportApi}) => {
	let response = await axios.get(csvExportApi, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
	return response.data
}



const getExportToCsvUserWorkSheet = async ({csvExportApi}) => {
	let response = await axios.get(csvExportApi, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
	return response.data
}

export const useGetExportToCsvUserWorkSheet = (
	
) => {
	const csvExportApi=`/api/exportToCsv/userWorkSheetExport?configs=${encodeURIComponent(JSON.stringify({workSheetContentType:"lessons",profileType:""}))}`
	return useQuery(
		['exportCsvDataContent',csvExportApi],
		() => getExportToCsvUserWorkSheet({csvExportApi}),
		{
			enabled: false,
		},
	)
}
const getExportToCsvContentBatched = async ({
  csvExportApi,
  batchSize = 50
}) => {
  try {
    // Extract the base URL and configs
    const [baseUrl, configsParam] = csvExportApi.split('?configs=');
    const decodedConfigs = JSON.parse(decodeURIComponent(configsParam));
    
    // First call to get initial data and total count
    const initialConfigs = {
      ...decodedConfigs,
      limit: batchSize,
      skip: 0
    };
    
    const initialUrl = `${baseUrl}?configs=${encodeURIComponent(JSON.stringify(initialConfigs))}`;
    const initialResponse = await axios.get(initialUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    // Add safety checks for response structure
    if (!initialResponse.data) {
      throw new Error('Invalid response: missing data');
    }
    
    // Extract JSON data, count, and custom header from the response
    const initialData = initialResponse.data.data; // JSON array
    const totalCount = initialResponse.data.count || 0;
    const customHeader = initialResponse.data.customHeader || null;
    
    console.log('Initial batch info:', {
      totalCount,
      batchSize,
      initialDataType: typeof initialData,
      initialDataLength: Array.isArray(initialData) ? initialData.length : 0,
      hasCustomHeader: !!customHeader,
      responseKeys: Object.keys(initialResponse.data) // Debug response structure
    });
    
    // Calculate total batches based on the count
    const totalBatches = Math.ceil(totalCount / batchSize);
    
    // Collect all JSON data starting with initial batch
    const allJsonData = Array.isArray(initialData) ? [...initialData] : [];
    
    // Only fetch more batches if there's more data
    if (totalBatches > 1) {
      console.log(`Fetching ${totalBatches - 1} additional batches...`);
      
      // Fetch remaining batches
      for (let batch = 1; batch < totalBatches; batch++) {
        try {
          const skip = batch * batchSize;
          
          const batchConfigs = {
            ...decodedConfigs,
            limit: batchSize,
            skip: skip
          };
          
          const batchUrl = `${baseUrl}?configs=${encodeURIComponent(JSON.stringify(batchConfigs))}`;
          
          console.log(`Fetching batch ${batch + 1}/${totalBatches}...`);
          
          const batchResponse = await axios.get(batchUrl, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          
          // Add safety checks for batch response
          if (!batchResponse.data) {
            console.warn(`Batch ${batch + 1} returned no data`);
            continue;
          }
          
          const batchData = batchResponse.data.data; // JSON array
          
          console.log(`Batch ${batch + 1}/${totalBatches} info:`, {
            type: typeof batchData,
            isArray: Array.isArray(batchData),
            length: Array.isArray(batchData) ? batchData.length : 0,
            responseKeys: Object.keys(batchResponse.data)
          });
          
          if (Array.isArray(batchData) && batchData.length > 0) {
            // Add all JSON objects from this batch
            allJsonData.push(...batchData);
            console.log(`Added ${batchData.length} records from batch ${batch + 1}`);
          } else if (Array.isArray(batchData) && batchData.length === 0) {
            console.log(`Batch ${batch + 1} returned empty array (expected for last batch)`);
          } else {
            console.warn(`Batch ${batch + 1} returned unexpected data format:`, {
              type: typeof batchData,
              isArray: Array.isArray(batchData),
              value: batchData
            });
          }
          
        } catch (batchError) {
          console.error(`Error fetching batch ${batch + 1}:`, batchError.message);
          // Continue with other batches instead of failing completely
          continue;
        }
        
        // Optional: Small delay to be gentle on the server
        if (batch < totalBatches - 1) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
      }
    }
    
    console.log(`Total JSON records collected: ${allJsonData.length}`);
    
    if (allJsonData.length === 0) {
      console.warn('No data collected from any batch');
      return customHeader || '';
    }
    
    // Convert all collected JSON data to CSV with preserved column order
    const csvData = convertJsonArrayToCsv(allJsonData);
    
    // Add custom header if it exists
    const finalResult = customHeader 
      ? `${customHeader}\r\n${csvData}`
      : csvData;
    
    console.log('CSV conversion complete:', {
      totalRecords: allJsonData.length,
      csvLines: csvData.split('\n').length,
      hasCustomHeader: !!customHeader,
      finalLength: finalResult.length
    });
    
    return finalResult;
    
  } catch (error) {
    console.error("JSON batch download to CSV failed:", error);
    console.error("Error details:", {
      message: error.message,
      stack: error.stack,
      csvExportApi: csvExportApi
    });
    
    // Fall back to standard download if batching fails
    try {
      return await getExportToCsvContent({ csvExportApi });
    } catch (fallbackError) {
      console.error("Fallback also failed:", fallbackError);
      throw new Error(`Both batched and standard export failed. Batched error: ${error.message}. Fallback error: ${fallbackError.message}`);
    }
  }
};

// Enhanced helper function to convert JSON array to properly formatted CSV with preserved column order
const convertJsonArrayToCsv = (jsonArray) => {
  if (!jsonArray || jsonArray.length === 0) {
    console.log('No JSON data to convert to CSV');
    return '';
  }
  
  try {
    // Build column order by processing records in sequence
    // This ensures earlier columns appear first, new columns get added at the end
    const columnOrderMap = new Map();
    let columnIndex = 0;
    
    jsonArray.forEach((record, recordIdx) => {
      if (record && typeof record === 'object' && !Array.isArray(record)) {
        Object.keys(record).forEach(key => {
          if (!columnOrderMap.has(key)) {
            columnOrderMap.set(key, columnIndex++);
            console.log(`Adding column "${key}" at position ${columnIndex - 1}`);
          }
        });
      } else {
        console.warn(`Record ${recordIdx} is not a valid object:`, {
          type: typeof record,
          isArray: Array.isArray(record),
          value: record
        });
      }
    });
    
    if (columnOrderMap.size === 0) {
      console.error('No valid columns found in JSON data');
      return '';
    }
    
    // Create ordered columns array based on appearance order
    const columns = Array.from(columnOrderMap.entries())
      .sort(([, indexA], [, indexB]) => indexA - indexB)
      .map(([columnName]) => columnName);
    
    console.log('CSV conversion info:', {
      totalRecords: jsonArray.length,
      totalColumns: columns.length,
      columnOrder: columns.slice(0, 10), // Log first 10 columns for debugging
      allColumns: columns.length <= 20 ? columns : `${columns.slice(0, 10).join(', ')}... (+${columns.length - 10} more)`
    });
    
    // Create header row
    const headerRow = columns.map(col => escapeCsvValue(col)).join(',');
    
    // Create data rows
    const dataRows = jsonArray.map((record, recordIndex) => {
      if (!record || typeof record !== 'object' || Array.isArray(record)) {
        console.warn(`Skipping invalid record at index ${recordIndex}:`, record);
        return columns.map(() => 'N/A').join(','); // Fill with N/A values
      }
      
      return columns.map(column => {
        const value = record[column];
        return escapeCsvValue(value);
      }).join(',');
    });
    
    // Combine header and data
    const result = [headerRow, ...dataRows].join('\n');
    
    console.log('CSV creation summary:', {
      headerPreview: headerRow.substring(0, 100) + (headerRow.length > 100 ? '...' : ''),
      totalDataRows: dataRows.length,
      sampleDataRow: dataRows[0]?.substring(0, 100) + (dataRows[0]?.length > 100 ? '...' : '') || 'No data rows',
      totalCsvLength: result.length
    });
    
    return result;
    
  } catch (error) {
    console.error('Error converting JSON to CSV:', error);
    throw new Error(`CSV conversion failed: ${error.message}`);
  }
};

// Helper function to properly escape CSV values
const escapeCsvValue = (value) => {
  try {
    // Handle null, undefined, or empty values
    if (value === null || value === undefined) {
      return 'N/A'; // Match your backend's defaultValue
    }
    
    // Handle arrays and objects
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return 'N/A';
      }
      // Convert arrays to semicolon-separated strings, handling nested objects
      const arrayString = value.map(item => {
        if (item === null || item === undefined) return '';
        if (typeof item === 'object') return JSON.stringify(item);
        return String(item);
      }).join('; ');
      return escapeCsvValue(arrayString);
    }
    
    if (typeof value === 'object') {
      return escapeCsvValue(JSON.stringify(value)); // Convert objects to JSON strings
    }
    
    // Handle boolean values
    if (typeof value === 'boolean') {
      return value ? 'TRUE' : 'FALSE';
    }
    
    // Handle numbers (including 0)
    if (typeof value === 'number') {
      return String(value);
    }
    
    // Convert to string
    let stringValue = String(value).trim();
    
    // Handle empty strings
    if (stringValue === '') {
      return 'N/A';
    }
    
    // Check if value needs to be quoted
    const needsQuoting = stringValue.includes(',') || 
                        stringValue.includes('"') || 
                        stringValue.includes('\n') || 
                        stringValue.includes('\r') ||
                        stringValue !== stringValue.trim(); // has leading/trailing whitespace
    
    if (needsQuoting) {
      // Escape existing quotes by doubling them
      stringValue = stringValue.replace(/"/g, '""');
      // Wrap in quotes
      return `"${stringValue}"`;
    }
    
    return stringValue;
    
  } catch (error) {
    console.error('Error escaping CSV value:', { value, error: error.message });
    return 'N/A'; // Fallback for any escaping errors
  }
};



export const useGetExportToCsvContent = ({
  findQuery,
  resourceType,
  activeFilters,
  taggedResourcesCount,
  useAggregation,
  population,
  lookupConfig,
  pluginId,
  populateTagsArray,
  enableUpdateExport,
  fieldsToSortAtEnd,
  dataFormat = "csv",
  isBatchDownload = false,
  batchSize,
  exportAnnotation,
  activeSort,
  colorbreakDownFilters,
  searchTerm,
  dataSource
}) => {
  const csvExportApi = `/api/exportToCsv/contentExport?configs=${encodeURIComponent(
    JSON.stringify({
      findQuery,
      resourceType,
      activeFilters,
      taggedResourcesCount,
      useAggregation,
      population,
      lookupConfig,
      pluginId,
      populateTagsArray,
      enableUpdateExport,
      fieldsToSortAtEnd,
      dataFormat,
      exportAnnotation,
      searchTerm,
      dataSource
    })
  )}`;
  
  return useQuery(
    ["exportCsvDataContent", csvExportApi, isBatchDownload, batchSize],
    ({ signal }) => {
      if (isBatchDownload) {
        console.log("Using batched download for large dataset");
        return getExportToCsvContentBatched({ 
          csvExportApi, 
          batchSize: batchSize 
        });
      } else {
        console.log("Using standard download");
        return getExportToCsvContent({ csvExportApi });
      }
    },
    {
      enabled: false,
      retry: 1,
      retryDelay: 1000,
    }
  );
};

